import React, { Component } from "react";
import { connect } from "react-redux";
import { compose } from "redux";
import { push } from "react-router-redux";
import { func, bool, shape, arrayOf, string, number } from "prop-types";

import Head from "pages/_components/Head";
import Notification from "pages/_components/Notification";
import * as i18n from "util/i18n";
import PageLoading from "pages/_components/PageLoading";
import { actions as servicePaymentsActions, selectors as servicePaymentsSelectors } from "reducers/servicePayments";
import { actions as paymentsAFIPActions, selectors as paymentsAFIPSelectors } from "reducers/paymentsAFIP";
import classNames from "classnames";
import Pagination from "pages/_components/pagination/Pagination";
import { resizableRoute } from "pages/_components/Resizable";
import { applyEmbeddedV3ShellLayoutState, clearEmbeddedV3ShellLayoutState } from "util/v3ShellLayoutSync";
import { getServicePaymentsPath } from "util/servicePaymentsRoutes";
import AdhesionesTable from "./_components/AdhesionesTable";

const FORM_ID = "services.adhesiones";

class AdhesionesList extends Component {
    state = {};

    static propTypes = {
        dispatch: func.isRequired,
        fetching: bool.isRequired,
        isDesktop: bool.isRequired,
        adhesiones: arrayOf(
            shape({
                adhesionCode: string,
                enteDescription: string,
                enteCode: string,
                userLp: string,
                category: shape({
                    code: string,
                    description: string,
                    shortDescrition: string,
                }),
                manejaBaseDeuda: bool,
            }),
        ).isRequired,
        isReturnFromDetail: bool.isRequired,
        totalPages: number.isRequired,
        pageNumber: number.isRequired,
        embeddedInV3Shell: bool,
    };

    static defaultProps = {
        embeddedInV3Shell: false,
    };

    componentDidMount() {
        const { dispatch } = this.props;

        dispatch(servicePaymentsActions.listAdhesiones());
        this.syncEmbeddedV3ShellLayout();
    }

    componentDidUpdate(prevProps) {
        const { embeddedInV3Shell, isDesktop } = this.props;
        if (
            embeddedInV3Shell &&
            (prevProps.embeddedInV3Shell !== embeddedInV3Shell || prevProps.isDesktop !== isDesktop)
        ) {
            this.syncEmbeddedV3ShellLayout();
        }
    }

    componentWillUnmount() {
        const { embeddedInV3Shell, dispatch } = this.props;
        if (embeddedInV3Shell) {
            clearEmbeddedV3ShellLayoutState(dispatch);
        }
    }

    syncEmbeddedV3ShellLayout = () => {
        const { dispatch, embeddedInV3Shell, isDesktop } = this.props;
        applyEmbeddedV3ShellLayoutState(dispatch, {
            embeddedInV3Shell,
            isDesktop,
            scopes: ["adhesiones"],
            titleKey: `${FORM_ID}.title`,
            goBackPath: getServicePaymentsPath(),
        });
    };

    handleBack = () => {
        const { dispatch, isReturnFromDetail, embeddedInV3Shell } = this.props;
        dispatch(paymentsAFIPActions.setIsBackFromOtherPage(isReturnFromDetail));
        if (embeddedInV3Shell) {
            dispatch(push(getServicePaymentsPath()));
        }
    };

    centerContentMobile = () => (
        <div className="title-account-header-multiline-background-blue">
            <h1 style={{ width: "100%", margin: "-0.2rem" }}>{i18n.get("services.adhesiones.title")}</h1>
        </div>
    );

    fetchNextPage = (pageNumber) => {
        const { dispatch } = this.props;
        dispatch(servicePaymentsActions.setPageNumber(pageNumber));
        dispatch(servicePaymentsActions.listAdhesiones());
    };

    render() {
        const { fetching, isDesktop, adhesiones, totalPages, pageNumber, embeddedInV3Shell } = this.props;

        return (
            <>
                {!embeddedInV3Shell && <Notification scopeToShow="adhesiones" />}
                {(!embeddedInV3Shell || isDesktop) &&
                    (isDesktop ? (
                        <>
                            <div className="admin-detail-head px-0">
                                <Head onBack={this.handleBack} centerContentClassName="pl-0" />
                                <Head
                                    title={`${FORM_ID}.title`}
                                    headerClassName={classNames({
                                        "py-2": isDesktop,
                                    })}
                                    centerContentClassName="pl-0"
                                />
                            </div>
                        </>
                    ) : (
                        <>
                            <div className="admin-detail-head px-0">
                                <Head
                                    title={`${FORM_ID}.title`}
                                    onBack={this.handleBack}
                                    headerClassName="blue-main-header-mobile adhesiones-list-title-mobile"
                                    centerContentClassName="mx-5"
                                />
                            </div>
                        </>
                    ))}
                <PageLoading loading={fetching}>{adhesiones && <AdhesionesTable isDesktop={isDesktop} />}</PageLoading>
                {!fetching && adhesiones && adhesiones.length > 0 && (
                    <div className="d-flex w-100 justify-content-end">
                        <Pagination totalPages={totalPages} pageNumber={pageNumber} action={this.fetchNextPage} />
                    </div>
                )}
            </>
        );
    }
}

const mapStateToProps = (state) => ({
    fetching: servicePaymentsSelectors.getFetching(state),
    adhesiones: servicePaymentsSelectors.getAdhesiones(state),
    isReturnFromDetail: paymentsAFIPSelectors.getIsReturnFromDetail(state),
    pageNumber: servicePaymentsSelectors.getPageNumber(state),
    totalPages: servicePaymentsSelectors.getTotalPages(state),
});

export default compose(connect(mapStateToProps), resizableRoute)(AdhesionesList);
